import { compose, reverse, find, curry, startsWith, anyPass, equals } from "ramda"

// 4px is our design grid step size
const step = 4

export function sizer(...props) {
  const unit = "px"
  return props.map((factor = 0) => (isNaN(factor) ? factor : factor * step + unit)).join(" ")
}

export function sizerNumber(num) {
  return num * step
}

export const noop = () => {}

export function getTextSize(size) {
  switch (size) {
    case "xs":
      // 12px
      return "0.75rem"
    case "sm":
      // 14px
      return "0.875rem"
    case "md":
      // 16px
      return "1rem"
    case "lg":
      // 24px
      return "1.5rem"
    case "xl":
      // 32px
      return "2rem"
    default:
      // 16px
      return "1rem"
  }
}

export function getLineHeight(size) {
  switch (size) {
    case "xs":
      // 16px
      return "1rem"
    case "sm":
      // 16px
      return "1rem"
    case "md":
      // 24px
      return "1.5rem"
    case "lg":
      // 27px
      return "1.6875rem"
    case "xl":
      // 36px
      return "2.25rem"
    default:
      return "normal"
  }
}

export function fullScreenEditorCloseHandler() {
  const lastNonEditorRoute = compose(
    // TODO: once backbone is gone, add in fallback routes to editors.
    // With backbone, the system dashboard route is always present, so fallback doesn't work.
    // defaultTo(onCloseFallbackRoute),
    find(hash => !hash.includes("#/editor")),
    reverse,
  )(window.routeHistory)

  window.location.hash = lastNonEditorRoute
  return lastNonEditorRoute
}

export const getStatusColor = (status, theme) => {
  switch (status) {
    case "HEALTHY":
      return theme.color.success["100"]
    case "UNHEALTHY":
      return theme.color.error["100"]
    case "NEEDS_ATTENTION":
      return theme.color.warning["100"]
    case "UNKNOWN":
    default:
      return theme.color.black["065"]
  }
}

export const getColorFromProps = curry(({ defaultTo }, { color, theme }) => {
  if (!color) {
    return getColorFromProps({}, { color: defaultTo ?? "unset", theme })
  }

  if (
    typeof color === "string" &&
    anyPass([equals("unset"), startsWith("#"), startsWith("rgb"), startsWith("hsl")])(color)
  ) {
    return color
  }

  if (!theme) throw new Error(`getColorFromProps: No theme provided for color: ${JSON.stringify(color)}.`)

  return (typeof color === "string" ? theme.color[color] : theme.color[color.code]?.[color.shade]) ?? "unset"
})
